import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Button } from "antd";
import { LeftOutlined, SaveOutlined } from "@ant-design/icons";

import ActivityForm from "./ActivityForm";
import activitiesActions from "../actions/activities";
import { WIDGET_TABS } from "./constants";

import styles from "./ActivityWidgetCreate.module.scss";

const ActivityWidgetCreate = ({ record, onBack }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Button
          icon={<LeftOutlined />}
          onClick={onBack}
          size="small"
          disabled={isLoading}
        >
          Back
        </Button>
        <Button
          icon={<SaveOutlined />}
          onClick={() => form.submit()}
          loading={isLoading}
          size="small"
        >
          Save
        </Button>
      </div>

      <div className={styles.form}>
        <ActivityForm
          form={form}
          record={record}
          showRecordFields
          onLoadingChange={setIsLoading}
          onSaved={() =>
            dispatch(activitiesActions.setWidgetActiveTab(WIDGET_TABS.LIST))
          }
        />
      </div>
    </div>
  );
};

export default ActivityWidgetCreate;
